export const colors = {
  black: "#000000E6",
  gray: "#666666",
  gray2: "#90949A",
  red: "#E8505B",
  black2: "#3A3A3A",
};


